import { isValidBIC } from "ibantools";

export const isValidBic =
  () =>
  (value: string): boolean =>
    isValidBIC(value);
